// extracted by mini-css-extract-plugin
export default {"header":"styles_header__yXLWd","container":"styles_container__pi78J","main":"styles_main__iOSqT","left":"styles_left__1qN59","right":"styles_right__U-QIT"};